import { AccountAPI } from "./apiUtils";

// http://localhost:3000/api/application-status
export const getApplicationStatus = async () => await AccountAPI.get("/application-status");

export const getCronStatus = async () => await AccountAPI.get("/cron-monitor");